import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './hooks/useAuth';
import { initGA, trackPage } from './utils/analytics';
import AuthGuard from './components/AuthGuard';
import Nav from './components/Nav';

import Landing        from './pages/Landing';
import Register       from './pages/Register';
import Login          from './pages/Login';
import Onboarding     from './pages/Onboarding';
import Feed           from './pages/Feed';
import Profile        from './pages/Profile';
import EmailConfirmed from './pages/EmailConfirmed';
import Settings        from './pages/Settings';
import Admin          from './pages/Admin';
import Moderation     from './pages/Moderation';
import NotFound       from './pages/NotFound';

import './styles/globals.css';

initGA();

function PageTracker() {
  const location = useLocation();
  useEffect(() => { trackPage(location.pathname); }, [location]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PageTracker />
        <Nav />
        <Routes>
          {/* Public */}
          <Route path="/"          element={<Landing />} />
          <Route path="/register"  element={<Register />} />
          <Route path="/login"     element={<Login />} />
          <Route path="/confirmed" element={<EmailConfirmed />} />

          {/* Protected */}
          <Route path="/onboarding" element={<AuthGuard><Onboarding /></AuthGuard>} />
          <Route path="/feed"       element={<AuthGuard><Feed /></AuthGuard>} />
          <Route path="/profile"    element={<AuthGuard><Profile /></AuthGuard>} />
          <Route path="/settings"    element={<AuthGuard><Settings /></AuthGuard>} />
          <Route path="/admin"       element={<AuthGuard><Admin /></AuthGuard>} />
          <Route path="/moderation"  element={<AuthGuard><Moderation /></AuthGuard>} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
